import * as React from 'react'

import { AsyncStatus } from '@ally/transmitigator'
import { LoginHeading } from '@ally/ally-login'

import { useTransmit } from '../../TransmitContext'
import { useAppState } from '../../AppStateProvider'
import { BusinessAccountForm, PersonalAccountForm } from './Forms'
import { useHostServices } from '../../HostServices'

const ForgotUsernameEmailLookupContent: React.FC<{
  status: AsyncStatus | 'Blocked' | 'Error'
  error?: string | undefined
}> = ({ status, error }) => {
  const hostServices = useHostServices()
  const { isWebWrapped } = useAppState()
  const [isAutoBusinessUser, setIsAutoBusinessUser] = React.useState(false)

  const toggleIsAutoBusinessUser = (): void => {
    setIsAutoBusinessUser(!isAutoBusinessUser)
  }

  React.useEffect(() => {
    hostServices?.analytics.trackPageView({
      eventType: 'pageview',
      pageName: isWebWrapped
        ? 'ally mobile app:Web View:Forgot Username'
        : 'AOS:Login:Forgot Username:Email Step',
    })
  }, [])

  return (
    <>
      <LoginHeading title="Forgot Username" />

      {isAutoBusinessUser ? (
        <BusinessAccountForm
          error={error}
          status={status}
          toggle={toggleIsAutoBusinessUser}
        />
      ) : (
        <PersonalAccountForm
          error={error}
          status={status}
          toggle={toggleIsAutoBusinessUser}
        />
      )}
    </>
  )
}

export const ForgotUsernameEmailLookup: React.FC = () => {
  const { activeScreen } = useTransmit()

  if (activeScreen.type !== 'ForgotUsername') {
    return null
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <ForgotUsernameEmailLookupContent {...activeScreen.payload} />
}
